import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { Button, Loading, Layout } from 'element-react';
import { DatePicker } from '../../components/Common';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Draggable from 'react-draggable';
import * as moment from 'moment';
import { getStepIds } from '../../utils/certificates';

class CreateDraftModal extends Component {

    fillStar = (e) => {
        let stars = document.getElementsByClassName('cert-star')
        stars = [].slice.call(stars);
        stars && stars.forEach(star => {
            if (star.dataset.value <= e.target.dataset.value) {
                star.innerHTML = '&#9733;'
            } else {
                star.innerHTML = '&#9734;'
            }
        })
    }

    render() {
        const { dataModel, t } = this.props;
        return (
            <React.Fragment>
              <Modal backdrop="static" isOpen={this.props.isOpen} className='draftmodal' id='section-to-print'>
                  <ModalHeader>
                    {t('certificationIssuance.createDraft')}
                    <Button style={{ position: 'absolute', right: '10px' }} onClick={() => this.props.toggle()}>{t('certificationIssuance.close')}</Button>
                  </ModalHeader>
                    <Loading loading={this.props.loading}>
                    <div className="buttons-container">
                        <Button
                            onClick={() => this.props.createPdf()}
                            style={{ flex: 1 }} type='primary'
                            disabled={
                                getStepIds(this.props.config, 'cert_draft_person').includes(this.props.user.id) ? false : true
                            }
                        >
                        原本作成/署名1依頼(TUV)
                        </Button>
                        <Button
                            style={{ flex: 1 }} type='primary'
                            disabled={true}
                        >
                        {t('certificationIssuance.sign')}
                        </Button>
                        <Button
                            style={{ flex: 1 }} type='primary'
                            disabled={true}
                        >
                        {t('certificationIssuance.handInDraft')}
                        </Button>
                        <Button
                            style={{ flex: 1 }} type='primary'
                            disabled={true}
                        >
                        {t('certificationIssuance.requestSignature')}
                        </Button>
                        <Button
                            style={{ flex: 1 }} type='primary'
                            disabled={true}
                        >
                        {t('certificationIssuance.sendConfirmation')}
                        </Button>
                    </div>
                    <div className="buttons-container">
                        {this.props.getScapFile(this.props.data) !== undefined ?
                            <Button type='primary'>
                                <span
                                    style={{ flex: 1 }}
                                    onClick={this.props.getScapFile(this.props.data) !== undefined ? () => this.props.openScapPreview(this.props.data) : null}>SCAP</span>
                            </Button> :
                            <Button disabled style={{ margin: 0}} type='primary'>SCAP</Button>
                        }
                        <Button
                            onClick={() => {}}
                            style={{ flex: 1 }} type='primary'
                            disabled={true}
                        >
                        {t('certificationIssuance.decline')}
                        </Button>
                        <Button
                            onClick={() => {}}
                            style={{ flex: 1 }} type='primary'
                            disabled={true}
                        >
                        {t('certificationIssuance.pullback')}
                        </Button>
                        <Button
                            onClick={() => {}}
                            style={{ flex: 1 }} type='primary'
                            disabled={true}
                        >
                        {t('certificationIssuance.remind')}
                        </Button>
                        <Button
                            onClick={() => {}}
                            style={{ flex: 1 }} type='primary'
                            disabled={true}
                        >
                        {t('certificationIssuance.cancel')}
                        </Button>
                    </div>
                    </Loading>
                  <ModalBody id="printable" className="user-container scrollable-modal">
                      <Layout.Row type='flex' align='right' justify='end' style={{ backgroundColor: '#f0f8ff', paddingBottom: '40px' }}>
                              <img style={{ margin: '25px -25px 0 0' }} src="img/kenjalogo.png" alt="logo" />
                      </Layout.Row>
                      <Layout.Row type='flex' align='center' justify='center' style={{ backgroundColor: '#f0f8ff' }}>
                              <h1 style={{ letterSpacing: '5px' }}>Certificate</h1>
                      </Layout.Row>
                      <Layout.Row type='flex' align='center' justify='center' style={{ backgroundColor: '#f0f8ff' }}>
                              <h1 style={{ letterSpacing: '2px' }}>適合認証書</h1>
                      </Layout.Row>
                      <Layout.Row style={{ width: '100%', textAlign: 'center', backgroundColor: '#f0f8ff' }}>
                              <p style={{ order: 1, fontSize: '3em', fontWeight: '100', margin: '-15px 0 50px 0', color: '#938953'}}>
                                  <span className='cert-star' data-value='1' onClick={(e) => this.fillStar(e)}>{[1, 2, 3].includes(dataModel.certification_issuance_id) ? <span>&#9733;</span> : <span>&#9734;</span>}</span>
                                  <span className='cert-star' data-value='2' onClick={(e) => this.fillStar(e)}>{[2, 3].includes(dataModel.certification_issuance_id) ? <span>&#9733;</span> : <span>&#9734;</span>}</span>
                                  <span className='cert-star' data-value='3' onClick={(e) => this.fillStar(e)}>{[3].includes(dataModel.certification_issuance_id) ? <span>&#9733;</span> : <span>&#9734;</span>}</span>
                              </p>
                      </Layout.Row>
                      <div className='section' style={{ height: '58%', backgroundColor: '#f0f8ff', position: 'relative' }}>
                      <Layout.Row style={{  width: '100%', padding: '0 20px' }}>
                          <Layout.Col sm='9'>
                              <Draggable>
                                  <div style={{ height: '53px' }} className='flex-container'>
                                      <p style={{ order: dataModel.is_domestic ? 1 : 2}}>認証取得組織：</p>
                                      <p style={{ order: dataModel.is_domestic ? 2 : 1}}>Certificate Holder:</p>
                                  </div>
                              </Draggable>
                          </Layout.Col>
                          <Layout.Col sm='15'>
                              <Draggable>
                              {dataModel.is_domestic ?
                                  <div>
                                      <p contenteditable='true'>{dataModel ? dataModel.transaction_company_name_jp : ''}</p>
                                      <p contenteditable='true'>{dataModel ? dataModel.address_jp : ''}</p>
                                  </div> :
                                  <div>
                                      <p contenteditable='true'>{dataModel ? dataModel.transaction_company_name_en : ''}</p>
                                      <p contenteditable='true'>{dataModel ? dataModel.address_en : ''}</p>
                                  </div>
                              }
                              </Draggable>
                              <Draggable>
                              {dataModel.is_domestic ?
                                  <div>
                                      <p contenteditable='true'>{dataModel ? dataModel.transaction_company_name_en : ''}</p>
                                      <p contenteditable='true'>{dataModel ? dataModel.address_en : ''}</p>
                                  </div> :
                                  <div>
                                      <p contenteditable='true'>{dataModel ? dataModel.transaction_company_name_ch : ''}</p>
                                      <p contenteditable='true'>{dataModel ? dataModel.address_ch : ''}</p>
                                  </div>
                              }
                              </Draggable>
                          </Layout.Col>
                      </Layout.Row>
                      <Layout.Row style={{ width: '100%', padding: '0 20px' }}>
                          <Layout.Col sm='9'>
                              <Draggable>
                                  <div className='flex-container'>
                                      <p style={{ order: dataModel.is_domestic ? 1 : 2}}>要求事項：</p>
                                      <p style={{ order: dataModel.is_domestic ? 2 : 1}}>Requirement:</p>
                                  </div>
                              </Draggable>
                          </Layout.Col>
                          <Layout.Col sm='15' className='flex-container'>
                              <Draggable>
                                  <div style={{ order: dataModel.is_domestic ? 1 : 2}}>
                                      <p>評価の結果、貴組織の文書化及び実施状況において、ISO  26000:2010を適用したセブン＆アイグループお取引先サステナブル行動指針にもとづく要求事項を満たす証拠が提示されたことを証明します。</p>
                                  </div>
                              </Draggable>
                              <Draggable>
                                  <div style={{ order: dataModel.is_domestic ? 2 : 1}}>
                                      <p >An assessment was performed, and it was determined that the requirements according to Seven&i Group Business Partner Sustainable Action Guidelines for its application of ISO 26000:2010 have been satisfied with respect to documentation and practical implementation.</p>
                                  </div>
                              </Draggable>
                          </Layout.Col>
                      </Layout.Row>
                      <Layout.Row style={{ width: '100%', padding: '0 20px' }}>
                          <Layout.Col sm='9'>
                              <Draggable>
                                  <div className='flex-container'>
                                      <p style={{ order: dataModel.is_domestic ? 1 : 2}}>認証書番号：</p>
                                      <p style={{ order: dataModel.is_domestic ? 2 : 1}}>Certificate No.:</p>
                                  </div>
                              </Draggable>
                          </Layout.Col>
                          <Layout.Col sm='15'>
                              <Draggable>
                                  <div><input autoComplete="off" onChange={(e) => this.props.onChangeHandler(e.currentTarget.value, 'audit_number')} type='text' value={dataModel ? dataModel.audit_number : ''} className='draft-input' /></div>
                              </Draggable>
                          </Layout.Col>
                      </Layout.Row>
                      <Layout.Row style={{ width: '100%', padding: '0 0 0 20px' }}>
                          <Layout.Col sm='5'>
                              <Draggable>
                                  <div className='flex-container'>
                                      <p style={{ order: dataModel.is_domestic ? 1 : 2}}>監査日：</p>
                                      <p style={{ order: dataModel.is_domestic ? 2 : 1}}>Audit Date:</p>
                                  </div>
                              </Draggable>
                          </Layout.Col>
                          <Layout.Col sm='7'>
                              <Draggable>
                                  <div><DatePicker onChange={(value) => this.props.onChangeHandler(value, 'audit_date')} className='single-date' value={dataModel && dataModel.audit_date ? dataModel.audit_date : new Date(moment())}/></div>
                              </Draggable>
                          </Layout.Col>
                          <Layout.Col sm='6'>
                              <Draggable>
                                  <div className='flex-container'>
                                      <p style={{ order: dataModel.is_domestic ? 1 : 2}}>認証書発行日：</p>
                                      <p style={{ order: dataModel.is_domestic ? 2 : 1}}>Certificate Issue Date:</p>
                                  </div>
                              </Draggable>
                          </Layout.Col>
                          <Layout.Col sm='6'>
                              <Draggable>
                                  <div><DatePicker onChange={(value) => this.props.onChangeHandler(value, 'cert_issuance_date')} className='single-date' value={dataModel && dataModel.cert_issuance_date ? dataModel.cert_issuance_date : new Date(moment())}/></div>
                              </Draggable>
                          </Layout.Col>
                      </Layout.Row>
                      <Layout.Row style={{ position: 'absolute', bottom: '0', width: '100%' }}>
                          <Layout.Col sm='12'>
                              <div style={{ textAlign: 'left', width: '80%', margin: 'auto' }} className='flex-container'>
                                  <div className='signature-line'></div>
                                  <p style={{ order: dataModel.is_domestic ? 2 : 3}}>株式会社ABC</p>
                                  <p style={{ order: dataModel.is_domestic ? 3 : 2}}>ABC Co., Ltd.</p>
                              </div>
                          </Layout.Col>
                          <Layout.Col sm='12'>
                              <div style={{ textAlign: 'right', width: '80%', margin: 'auto' }} className='flex-container'>
                                  <div className='signature-line'></div>
                                  <p style={{ order: dataModel.is_domestic ? 2 : 3}}>監査機関</p>
                                  <p style={{ order: dataModel.is_domestic ? 3 : 2}}>Audit Institution</p>
                              </div>
                          </Layout.Col>
                      </Layout.Row>
                      </div>
                      <Layout.Row style={{ height: '12%' }}>
                          <div style={{ position: 'relative', width: '100%', height: '100%' }}></div>
                      </Layout.Row>
                  </ModalBody>
                  <ModalFooter></ModalFooter>
              </Modal>
            </React.Fragment>
        );
    }
}

export default withNamespaces()(CreateDraftModal);
